import { TrailblazerEdgeType } from "./TrailblazerTypes";

/**
 * Class representing an edge in the graph.
 */
export default class TrailblazerEdge {
    constructor(source, target, edgeType = TrailblazerEdgeType.DIRECT, label = "") {
        this.source = source;
        this.target = target;
        this.label = label;
        this.edgeType = edgeType;
    }

    /**
     * Converts the edge to a Cytoscape element.
     */
    toCytoscapeElement() {
        return {
            data: {
                id: `${this.source}-${this.target}-${this.edgeType}`,
                source: this.source,
                target: this.target,
                label: this.label,
                edgeType: this.edgeType
            }
        };
    }
}